import { TriggerSevirity, Conditions, TriggerInput } from 'src/services/graphql/Models';
import ContactInfo from './ContactInfo';
import { Parsable } from 'src/shared/utility';

export default class Trigger implements TriggerInput, Parsable {
  id?: string | null;
  name: string;
  description?: string | null;
  triggerSevirity: TriggerSevirity;
  triggerCondition: Conditions;
  value?: number | null;
  state?: string | null;
  contacts?: Array< ContactInfo > | null;
  notifyOnFailure?: boolean | null;
  
  constructor ( from: any ) { 
    this.id = from.id;
    this.name = from.name;
    this.description = from.description;
    this.triggerSevirity = from.triggerSevirity;
    this.triggerCondition = from.triggerCondition;
    this.value = from.value;
    this.state = from.state;
    this.contacts = ( from.contacts || [] ).map(o => new ContactInfo(o));
    this.notifyOnFailure = from.notifyOnFailure;
  }

  parseAbsolute() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      triggerSevirity: this.triggerSevirity,
      triggerCondition: this.triggerCondition,
      value: this.value,
      state: this.state,
      notifyOnFailure: this.notifyOnFailure,
      contacts: ( this.contacts || [] ).map(o => o.parseAbsolute())
    };
  }
}


// WEBPACK FOOTER //
// ./src/stores/application/classes/Trigger.ts